export type DefensiveApproach = "Deep" | "Balanced" | "High" | "Aggressive";

// In-game bands are 30 wide: 1-30 Deep, 31-60 Balanced, 61-90 High, 91+ Aggressive.
export const defensiveApproachForLineHeight = (
  lineHeight: number,
): DefensiveApproach => {
  if (lineHeight <= 30) return "Deep";
  if (lineHeight <= 60) return "Balanced";
  if (lineHeight <= 90) return "High";
  return "Aggressive";
};
